// removed by extract-text-webpack-plugin
module.exports = {"FAQList":"_1bqZmTmhLQ6K0joIkYzh1t","FAQSearchInput":"_1nyyGQq4ziJsA3YMzFZaNv","FAQItem":"p9HU1AjpZAwcCzH5hH6YG","FAQListItem":"_37V4DQ02KnP3VB-vNsm_Tg"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Normal/List/style.css
// module id = 2026
// module chunks = 0